import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { TransitionGroup } from 'react-transition-group'

import { ErrorMessage } from 'components/atoms'
import { CarouselSlide } from 'components/molecules'
import { DEFAULT_TRANSITION_TIME } from 'constants/appConstants'
import useGetContentById from 'hooks/useGetContentById'
import { extractLayoutFromContent } from 'utils/layout'

const ShowContentCmd = ({ contentType, contentId, setContentAttributes }) => {
  const content = useGetContentById(contentType, contentId)

  useEffect(() => {
    if (!content || !content.data) {
      return
    }

    const layout = extractLayoutFromContent(content.data)
    setContentAttributes({ contentType, layout })
  }, [content])

  return (
    content.data && (
      <TransitionGroup>
        <CarouselSlide
          key={contentType + contentId}
          content={{ ...content.data, contentType }}
          timeout={DEFAULT_TRANSITION_TIME}
        />
      </TransitionGroup>
    )
  )
}

ShowContentCmd.propTypes = {
  contentType: PropTypes.string,
  contentId: PropTypes.string,
  setContentAttributes: PropTypes.func,
}

const PayloadContent = ({ payload, setContentAttributes }) => {
  const InvalidLayout = useCallback(() => <ErrorMessage title='Invalid payload command' />)

  const { command } = payload
  if (command === 'showContent' || command === 'play' || command === 'pause') {
    const { contentType, contentId } = payload.data

    return (
      <ShowContentCmd contentType={contentType} contentId={contentId} setContentAttributes={setContentAttributes} />
    )
  }

  return <InvalidLayout />
}

PayloadContent.defaultProps = {
  payload: {},
  setContentAttributes: () => {},
}

PayloadContent.propTypes = {
  payload: PropTypes.object,
  setContentAttributes: PropTypes.func,
}

export default PayloadContent
